import {
  Tooltip,
  TooltipAncestorContext,
  TooltipProps,
} from '@design/components/tooltip/Tooltip';
import { useTouchDevice } from '@terminal/hooks/MediaQueryHook';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './TooltipContainer.module.scss';

export type TooltipContainerProps = Omit<
  TooltipProps,
  'closeLabel' | 'isTouchDevice' | 'children'
> & {
  children?: TooltipProps['children'];
  showUnderline?: boolean;
  ref?: React.Ref<HTMLElement>;
};

export const TooltipContainer = (props: TooltipContainerProps) => {
  const isTouchDevice = useTouchDevice();
  const { t } = useTranslation('common');
  const isNestedInTooltip = useContext(TooltipAncestorContext);

  if (!props.children) {
    return null;
  }

  if (!props.label || isNestedInTooltip) {
    return props.children;
  }

  return (
    <Tooltip
      {...props}
      closeLabel={t('common:tapToClose')}
      isTouchDevice={isTouchDevice}
    >
      {props.showUnderline ? (
        <div className={styles.underlineText}>{props.children}</div>
      ) : (
        props.children
      )}
    </Tooltip>
  );
};
